
import { Vue } from 'vue-class-component'
import { OpenAPI, Group, Question, AuthService, Answer, GroupService } from '@/api'
import dayjs from 'dayjs'

export default class Settings extends Vue {
  group: Group | null = null
  ttl: string | null = null
  expired: boolean | null = null
  blocked = false
  saved = false

  date () : string {
    return dayjs(this.ttl).format('DD.MM.YYYY HH:mm')
  }

  mounted (): void {
    OpenAPI.BASE = window.FRONT_API_URL

    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')

    if (token === null) {
      return
    }

    AuthService.getTokenData({ token }).then(data => {
      this.ttl = data.ttl

      return GroupService.getGroup({ token })
    }).then(group => {
      this.group = group
    }).catch(() => {
      this.expired = true
    })
  }

  addQuestion (): void {
    if (this.group === null) {
      return
    }

    const q: Question = {
      text: '',
      answers: []
    }

    this.group.questions.push(q)
  }

  addDomain (): void {
    if (this.group === null) {
      return
    }

    if (this.group.ignore_domains === undefined) {
      this.group.ignore_domains = ['']
    } else {
      this.group.ignore_domains.push('')
    }
  }

  addDefaultDomains (): void {
    if (this.group === null) {
      return
    }

    const defaultDomains = [
      'github.com',
      'pastebin.com',
      'habr.com',
      'perlbanjo.com',
      'metacpan.org'
    ]

    if (this.group.ignore_domains === undefined) {
      this.group.ignore_domains = defaultDomains
    } else {
      this.group.ignore_domains.push(...defaultDomains)
    }
  }

  deleteQuestion (questionIndex: number): void {
    if (this.group === null) {
      return
    }

    if (this.group.questions[questionIndex] === undefined) {
      return
    }

    this.group.questions.splice(questionIndex, 1)
  }

  addAnswer (index: number): void {
    if (this.group === null) {
      return
    }

    const answer: Answer = {
      text: ''
    }

    this.group.questions[index].answers.push(answer)
  }

  deleteAnswer (questionIndex: number, answerIndex: number): void {
    if (this.group === null) {
      return
    }

    if (this.group.questions[questionIndex] === undefined) {
      return
    }

    if (this.group.questions[questionIndex].answers[answerIndex] === undefined) {
      return
    }

    this.group.questions[questionIndex].answers.splice(answerIndex, 1)
  }

  deleteDomain (idx: number): void {
    if (this.group === null) {
      return
    }

    if (this.group.ignore_domains === undefined) {
      return
    }

    if (this.group.ignore_domains[idx] === undefined) {
      return
    }

    this.group.ignore_domains.splice(idx, 1)
  }

  save (e: Event): void {
    e.preventDefault()

    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get('token')

    if (token === null) {
      return
    }

    if (this.group === null) {
      return
    }

    if (this.group.ignore_domains !== undefined && this.group.ignore_domains.length === 0) {
      this.group.ignore_domains = undefined
    }

    this.blocked = true

    GroupService.saveGroup({ token, requestBody: this.group }).then(() => {
      this.saved = true
    }).finally(() => {
      this.blocked = false
    })
  }
}
